"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var shared_1 = require("mad-utils/lib/shared");
/**************************************** PROJECT MODULES *****************************************/
var kotlin_map_factory_1 = require("../../util/kotlin-map-factory");
var javelin_exports_1 = require("../../javelin-exports");
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
exports.SyncManager = javelin_exports_1.javelin.sync.util.SyncManager;
shared_1.defineMethod(exports.SyncManager.prototype, 'confirmAccount', function confirmAccount(params, callback) {
    var mapParams = kotlin_map_factory_1.dirtyKotlinMap(params);
    return this._confirmAccount(mapParams, callback);
});
shared_1.defineProp(exports.SyncManager.prototype, 'JVLN_CLASS_NAME', 'SyncManager', false);
//# sourceMappingURL=sync-manager.js.map